import Icon from '@components/atoms/icon';
import { BodyRegularBold } from '@components/atoms/typography';

const UltraBadge = () => (
  <div className="rounded-lg bg-[#DDA42E] px-3 py-2 flex items-center text-neutral-50">
    <BodyRegularBold textColor="text-neutral-50">Ultra member</BodyRegularBold>
    <Icon name="Star" className="ml-2" />
  </div>
);

export default UltraBadge;
